import {NgModule} from '@angular/core';
// import {KAlertModule} from 'ngx-k-components/alert';
// import {KBadgeModule} from 'ngx-k-components/badge';
// import {KButtonModule} from 'ngx-k-components/button';
// import {KCardModule} from 'ngx-k-components/card';

@NgModule({
	declarations: [],
	exports: [
		// KAlertModule,
		// KBadgeModule,
		// KButtonModule,
		// KCardModule
	]
})
export class KComponentsModule {
}
